
export default {
  // Hero Section
  'hero.slide1.title': 'Умные теплицы для зеленого будущего',
  'hero.slide1.subtitle': 'Голландские технологии, иранское качество',
  'hero.slide1.description': 'С более чем 15-летним опытом, лидеры в строительстве современных теплиц и передового сельскохозяйственного оборудования',
  'hero.slide2.title': 'Передовые сельскохозяйственные технологии',
  'hero.slide2.subtitle': 'Умные системы орошения и климат-контроля',
  'hero.slide2.description': 'Предоставление самых комплексных технологических решений для повышения производительности и качества сельскохозяйственной продукции',
  'hero.slide3.title': 'Надежный партнер иранских фермеров',
  'hero.slide3.subtitle': 'Более 50 успешных проектов по всей стране',
  'hero.slide3.description': 'От проектирования до реализации и поддержки, сопровождаем вас на пути развития современного и устойчивого сельского хозяйства',
  
  // Buttons
  'buttons.view_products': 'Посмотреть продукты',
  'buttons.request_consultation': 'Запросить консультацию',
  'buttons.view_projects': 'Проекты',
  
  // Stats Section
  'stats.projects': 'Успешных проектов',
  'stats.area': 'Квадратных метров построено',
  'stats.experience': 'Лет опыта',
  'stats.customers': 'Довольных клиентов',
  
  // Services Section
  'services.title': 'Наши услуги',
  'services.description': 'Предоставление самых комплексных услуг по проектированию, строительству и обслуживанию современных теплиц',
  'services.design.title': 'Проектирование и строительство теплиц',
  'services.design.description': 'Проектирование и строительство современных теплиц с мировыми технологиями и международными стандартами',
  'services.smart.title': 'Умные системы',
  'services.smart.description': 'Установка и настройка систем климат-контроля, орошения и умного мониторинга',
  'services.consulting.title': 'Профессиональное консультирование',
  'services.consulting.description': 'Предоставление профессиональных консультаций в области современного сельского хозяйства и оптимизации производства',
  'services.maintenance.title': 'Обслуживание и поддержка',
  'services.maintenance.description': 'Круглосуточные услуги обслуживания, ремонта и поддержки для всего оборудования',
  
  // About Section
  'about.title': 'О компании Iran GH',
  'about.description1': 'Лидеры в строительстве современных теплиц и предоставлении инновационных сельскохозяйственных решений',
  'about.why_us.title': 'Почему Iran GH?',
  'about.why_us.experience': 'Более 15 лет успешного опыта',
  'about.why_us.quality': 'Гарантированное качество продукции',
  'about.why_us.support': 'Поддержка экспертов 24/7',
  'about.why_us.projects': 'Более 50 успешных проектов',
  'about.why_us.description': 'Основываясь на опыте и технических знаниях, мы предоставляем лучшие тепличные решения для вас.',
  'about.expertise.title': 'Наша экспертиза',
  'about.expertise.smart_design': 'Проектирование умных теплиц',
  'about.expertise.climate_control': 'Системы климат-контроля',
  'about.expertise.irrigation': 'Передовое оросительное оборудование',
  'about.expertise.consulting': 'Профессиональное сельскохозяйственное консультирование',
  'about.expertise.description': 'Наша команда экспертов предоставляет инновационные решения, используя новейшие технологии.',
  'about.partnership.title': 'Международное партнерство',
  'about.partnership.dutch_tech': 'Передовые голландские технологии',
  'about.partnership.vander_hoeven': 'Партнерство с Vander Hoeven',
  'about.partnership.european_standards': 'Европейские стандарты',
  'about.partnership.global_quality': 'Глобальная гарантия качества',
  'about.partnership.description': 'Через международные партнерства мы предоставляем вам лучшие технологии мира.',
  'about.cta.title': 'Готовы работать с вами',
  'about.cta.description': 'От бесплатной консультации до полной реализации проекта, мы будем с вами на всех этапах',
  'about.cta.learn_more': 'Узнайте больше о нас',
  'about.cta.contact': 'Свяжитесь с нами',
  
  // Partners Section
  'partners.title': 'Наши партнеры',
  'partners.description': 'Сотрудничество с самыми авторитетными отечественными и зарубежными компаниями в области тепличных технологий',
  'partners.international': 'Международные партнерства',
  'partners.vander.name': 'Vander Hoeven',
  'partners.vander.country': 'Официальный голландский партнер',
  'partners.vander.years': '10+ лет сотрудничества',
  'partners.vander.tech': 'Передовые голландские технологии',
  'partners.vander.description': 'Официальный голландский партнер с более чем 10-летним успешным сотрудничеством',
  'partners.chehelsotoon.name': 'Chehelsotoon',
  'partners.chehelsotoon.country': 'Отечественный деловой партнер',
  'partners.chehelsotoon.years': '8+ лет сотрудничества',
  'partners.chehelsotoon.quality': 'Качественное местное производство',
  'partners.chehelsotoon.description': 'Отечественный деловой партнер с качественным местным производством',
  'partners.benefits.title': 'Преимущества наших партнерств',
  'partners.benefits.description': 'Почему партнерство с нами - правильный выбор?',
  'partners.benefits.global_access': 'Глобальный доступ',
  'partners.benefits.global_desc': 'Связь с международными рынками',
  'partners.benefits.advanced_tech': 'Передовые технологии',
  'partners.benefits.tech_desc': 'Новейшие мировые технологии',
  'partners.benefits.quality_guarantee': 'Гарантия качества',
  'partners.benefits.quality_desc': 'Международные стандарты качества',
  'partners.benefits.support': 'Поддержка 24/7',
  'partners.benefits.support_desc': 'Профессиональные послепродажные услуги',
  'partners.cta': 'Станьте нашим партнером',
  
  // Testimonials Section
  'testimonials.title': 'Отзывы клиентов',
  'testimonials.description': 'Что говорят наши клиенты о качестве наших услуг и продукции',
  'testimonials.customer1.name': 'Ахмад Мохаммади',
  'testimonials.customer1.position': 'Менеджер сельскохозяйственного комплекса в Исфахане',
  'testimonials.customer1.text': 'Качество строительства и оборудования Iran GH превосходное. Наша теплица построена с лучшими технологиями.',
  'testimonials.customer2.name': 'Фатеме Карими',
  'testimonials.customer2.position': 'Сельскохозяйственный эксперт в Мешхеде',
  'testimonials.customer2.text': 'Сотрудничество с Iran GH было отличным опытом. Все было выполнено профессионально от проектирования до реализации.',
  'testimonials.customer3.name': 'Реза Ахмади',
  'testimonials.customer3.position': 'Владелец теплицы в Ардебиле',
  'testimonials.customer3.text': 'Голландские технологии и иранские услуги, отличное сочетание, которое привело к успеху нашего бизнеса.',
  
  // CTA Section
  'cta.title': 'Готовы начать свой следующий проект?',
  'cta.description': 'Свяжитесь с нашей командой экспертов и получите бесплатную консультацию',
  'cta.phone': '+98 21 8844 1386',
  
  // Navigation
  'nav.read_more': 'Читать далее',
  'nav.view_services': 'Посмотреть услуги',
  'nav.view_partners': 'Посмотреть партнеров',
  'nav.cooperation_level': 'Уровень сотрудничества',
  
  // Story Section (added)
  story: {
    badge: 'История компании Aria Green House',
    title: 'История успеха Aria Green House',
    subtitle: 'Компания Aria Green House с более чем 15-летним опытом в проектировании, строительстве и оснащении современных теплиц является лидером в тепличной индустрии Ирана и региона Ближнего Востока.',
    founding: {
      title: 'Основание Aria Green House',
      description: 'Aria Green House была основана в 2009 году с целью предоставления инновационных решений в тепличной индустрии. Наша компания превратилась из небольшого инженерного подразделения в крупнейшего поставщика тепличного оборудования в стране.'
    },
    growth: {
      title: 'Рост и развитие Aria Green House',
      description: 'За годы нашей деятельности Aria Green House успешно завершила более 200 проектов по всей стране и региону. От небольших семейных теплиц до крупных коммерческих комплексов - все входит в область нашей экспертизы.'
    },
    achievements: {
      title: 'Достижения Aria Green House',
      description: 'Сегодня Aria Green House признана лидером в области технологий умных теплиц и помогает фермерам достигать более высоких урожаев через оптимальное использование ресурсов.'
    },
    image_alt: 'История и достижения компании Aria Green House',
    highlight: {
      title: 'Aria Green House - Пионер в инновациях',
      description: 'Более 150,000 квадратных метров построенных теплиц и 100+ довольных клиентов'
    },
    timeline: {
      title: 'Путь развития Aria Green House',
      2009: {
        title: 'Начало деятельности',
        description: 'Основание Aria Green House со специализированной и преданной командой'
      },
      2015: {
        title: 'Расширение услуг',
        description: 'Предоставление услуг по проектированию и строительству умных теплиц'
      },
      2020: {
        title: 'Лидерство на рынке',
        description: 'Становление лидером в тепличной индустрии Ирана'
      },
      2024: {
        title: 'Непрерывные инновации',
        description: 'Внедрение передовых технологий IoT и искусственного интеллекта'
      }
    },
    milestones: {
      projects: {
        title: 'Успешные проекты Aria Green House',
        subtitle: 'Более 200 завершенных проектов',
        description: 'Aria Green House приобрела богатый опыт и высокую экспертизу благодаря успешной реализации разнообразных проектов, от небольших семейных теплиц до крупных коммерческих комплексов.',
        item1: 'Передовые гидропонные теплицы',
        item2: 'Умные системы климат-контроля',
        item3: 'Автоматическое оросительное оборудование'
      },
      expansion: {
        title: 'Региональное расширение Aria Green House',
        subtitle: 'Присутствие на Ближнем Востоке',
        description: 'Aria Green House расширила свою деятельность на соседние страны и признана специализированным справочником в регионе Ближнего Востока.',
        item1: 'Экспорт оборудования в соседние страны',
        item2: 'Международное техническое консультирование и проектирование',
        item3: 'Партнерство с авторитетными региональными компаниями'
      }
    },
    innovation: {
      title: 'Инновации в Aria Green House',
      subtitle: 'Aria Green House всегда находится в авангарде новых технологий и предоставляет передовые решения через непрерывные исследования и разработки.',
      research: {
        title: 'Исследования и разработки',
        description: 'Непрерывные инвестиции в научные исследования и разработку новых тепличных технологий'
      },
      technology: {
        title: 'Умные технологии',
        description: 'Внедрение систем IoT, искусственного интеллекта и передовой автоматизации'
      },
      sustainability: {
        title: 'Экологическая устойчивость',
        description: 'Фокус на экологически чистых решениях и оптимальном потреблении ресурсов'
      }
    }
  }
};
